// extracted by mini-css-extract-plugin
export default {"root":"ResultsSlider_root__c0lvj","buttons":"ResultsSlider_buttons__t8JC1"};